import { Component, Input, Output, EventEmitter } from "@angular/core";
import { CurrencyPipe } from "@angular/common";
import { SeriesVerticalComponent, BarChartModule, TooltipModule } from "@swimlane/ngx-charts";
import { select } from "d3-selection";

@Component({
    selector: "g[kilowant-charts-series-vertical]",
    templateUrl: "../../../html/chart/kilowant-charts-series-vertical.html",
    imports: [BarChartModule, TooltipModule]
})

export class KilowantSeriesVerticalComponent extends SeriesVerticalComponent {
    @Input() prefix: string;
    @Input() pos: number;
    @Input() showkWh: boolean=true;
    @Input() astericsPositions: number[] = [];
    @Output("offerSelected") offerSelectedEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

    x: number;
    y: number;
    minY: number;
    width: number;

    ngOnInit() {
    }

    ngOnChanges(): void {
        this.update();
    }

    update(): void {
        super.update();
        this.x = this.bars[0].x;
        this.y = this.bars[0].y;
        this.minY = this.bars[0].y;
        for (let i = 0; i < this.bars.length; i++) {
            this.width += this.bars[i].width;

            if (this.minY > this.bars[i].y) {
                this.minY = this.bars[i].y;
            }
        }
        var t = this;
        setTimeout(() => { t.drawNumber(); }, 1000);
    }

    selectOffer(): void {
        this.offerSelectedEmitter.next(true);
    }

    drawNumber(): void {
        let p = this.prefix + '_' + this.pos;

        for (let i = 0; i < this.bars.length; i++) {
            let barWidth = this.bars[i].width;
            let x = this.bars[i].x;
            select("#bar-text-" + p + "-" + i).attr("x", function (d) {
                let xNum = 0;
                if (this != null) {
                    let textWidth = (<SVGTextElement>this).getComputedTextLength();
                    xNum = x + (barWidth - textWidth) / 2
                } else {
                    xNum = 0;
                }
                return xNum;
            });
        }
    }

    getFormattedText(val: number, i: number): string {
        let text = (new CurrencyPipe("en-US")).transform(val, "USD", "symbol", "1.5-5") + "";
        if (this.showkWh) {
            text = text + "/kWh";
        }
        if (this.astericsPositions.includes(i)) {
            text = text + " *";
        }
        return text;
    }

    isLightColor(inColor: string): boolean {
        if (inColor.substring(0, 1) == "#") {
            inColor = inColor.substring(1);
        }
        var rgb = parseInt(inColor, 16);
        var r = (rgb >> 16) & 0xff;
        var g = (rgb >> 8) & 0xff;
        var b = (rgb >> 0) & 0xff;
        var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b;
        return (luma > 130);
    }

}